import { Controller } from 'stimulus'

// Makes a modal (e.g. the access link disable/enable/delete/QR modals, which
// StimulusReflex morphs into the page) usable with a keyboard:
//   - focus moves into the modal when it appears
//   - Tab / Shift+Tab stay inside it
//   - Esc, the close button, Cancel and the backdrop close it
//   - focus goes back to where it was when it closes
//
//   %form.modal{ data: { controller: "modal", action: "keydown->modal#keydown" } }
//     %a.modalClose{ data: { action: "click->modal#close" } }
const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

export default class extends Controller {
  connect() {
    this.returnFocusTo = document.activeElement
    this.element.setAttribute('aria-modal', 'true')

    // Start on the dialog itself, so screen readers read its title, and the
    // next Tab goes to its first control (rather than a destructive button)
    this.content = this.element.querySelector('.modal__content') || this.element
    this.content.setAttribute('tabindex', '-1')
    this.content.focus({ preventScroll: true })
  }

  keydown(event) {
    if (event.key === 'Escape') {
      this.close(event)
    } else if (event.key === 'Tab') {
      this.trapFocus(event)
    }
  }

  close(event) {
    if (event) event.preventDefault()
    const returnTo = this.returnFocusTo
    this.element.remove()
    // The element that opened the modal may have been re-rendered since
    if (returnTo && document.body.contains(returnTo)) {
      returnTo.focus()
    } else {
      document.getElementById('main-content')?.focus()
    }
  }

  trapFocus(event) {
    const focusable = [...this.content.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null)
    if (focusable.length === 0) return event.preventDefault()

    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    const active = document.activeElement
    if (event.shiftKey && (active === first || active === this.content)) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && active === last) {
      event.preventDefault()
      first.focus()
    }
  }
}
